// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3cF93","col":"Table_col__1QYA6","fulfillmentStatus":"Table_fulfillmentStatus__3YwK2","emailCol":"Table_emailCol__1THO3"};